import { get } from "@/apis";
import message from "ant-design-vue/lib/message";

export default {
  namespaced: true,
  state: {
    alias: 0,
    configLoaded: false,
    config: {
      id: 0,
      activityId: 0,
      name: "",
      verifyMode: 0,
      conditionConfiguration: "",
      tipExplanation: "",
      displayConfiguration: "",
      ruleConfiguration: "",
      buttonConfiguration: "",
      modalConfiguration: "",
      universalVerificationCode: "",
      smsSignature: "",
      banner: "",
      footer: "",
      systemPrimaryColor: "",
      systemInverseColor: "",
      note: "",
    },
  },
  mutations: {
    SET_ALIAS(state, payload) {
      state.alias = payload;
    },
    SET_CONFIG(state, payload) {
      state.config = payload;
    },
    SET_CONFIG_LOADED(state, payload) {
      state.configLoaded = payload;
    },
  },
  getters: {
    getConfig: (state) => {
      return state.config;
    },
    getConfigLoaded: (state) => {
      return state.configLoaded;
    },
  },
  actions: {
    async setConfig(context, data) {
      message.open({
        content: "配置加载中...",
        type: "loading",
        duration: 1,
      });
      const { alias } = data;
      const res = await get(`/api/ActivationWeb/GetConfig?alias=${alias}`);
      if (res.code == 200 && res.success) {
        // 设置系统主色
        document.documentElement.style.setProperty(
          "--primary-color",
          res.data.systemPrimaryColor
        );
        // 设置系统反色
        document.documentElement.style.setProperty(
          "--primary-inverse-color",
          res.data.systemInverseColor
        );

        document.title = `${res.data.name} - ${res.data.nameEn}`;

        context.commit("SET_ALIAS", res.data.alias);
        context.commit("SET_CONFIG", res.data);
      }
    },
    setConfigLoaded(context, data) {
      context.commit("SET_CONFIG_LOADED", data);
    },
  },
};
